import {Component, EventEmitter, Input} from '@angular/core';
import {ILeaderboard} from "./models/leaderboard.model";
import {Location} from "@angular/common";
import {EventBusService} from "../../../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../base/services/subscription-container.service";
import {AuthService} from "../../auth/services/auth.service";
import {NotifierService} from "../../../../../base/services/notifier/notifier.service";
import {LeaderboardService} from "./services/leaderboard.service";
import {MatDialog} from "@angular/material/dialog";
import {BaseComponent} from "../../../../../base/components/base.component";
import {RedeemComponent} from "../../../../webapp/components/redeem/redeem.component";
import {IWallet} from "../wallet/models/wallet.model";
import {EventKey} from "../../../../../registry/event.key";
import {IAuth} from "../../auth/models/auth.model";
import {HttpErrorResponse} from "@angular/common/http";
import {TextUtility} from "../../utility/text.utility";
import {BaseDialogComponent} from "../../../../../base/components/base-dialog.component";
import {WalletService} from "../wallet/services/wallet.service";

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss']
})
export class LeaderboardComponent extends BaseComponent implements BaseDialogComponent<null> {
  @Input() username: string | null = null
  @Input() leaderboard: ILeaderboard | null = null
  @Input() wallet: IWallet | null = null

  onCanceled: EventEmitter<void> = new EventEmitter<void>();
  onCompleted: EventEmitter<null> = new EventEmitter<null>();

  showRecentTransactions: boolean = false

  constructor(private location: Location,
              eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              private authService: AuthService,
              private notifier: NotifierService,
              private dialog: MatDialog,
              private leaderboardService: LeaderboardService,
              private walletService: WalletService) {
    super(eventBus, router, subContainer)
    if (this.username == null)
      this.username = this.getAuthUsername()
  }

  protected componentName(): string {
    return "LeaderboardComponent";
  }

  ngOnInit(): void {
    if (this.leaderboard == null)
      this.fetchLeaderboard()
    if (this.wallet == null)
      this.fetchWallet()
  }

  getAuth(): IAuth {
    return this.authService.getAuth()
  }

  getAuthUsername(): string {
    return this.authService.getPayload().preferred_username
  }

  isMyProfile(): boolean {
    if (!this.authService.isAuthenticatedAsync()) return false
    return this.getAuthUsername() === this.username
  }

  private fetchLeaderboard() {
    this.loading = true
    if (this.username == null) return
    let key = this.componentKey(EventKey.LEADERBOARDS.FETCH_LEADERBOARD(this.username))
    this.leaderboardService.fetchLeaderboard(key, this.username)
    this.subscribe(key, null, (value, meta) => {
      this.leaderboard = meta.data
      this.loading = false
    })
    this.subscribe(this.getErrorKey(key), null, (value, meta) => {
      let error: HttpErrorResponse = meta.data
      this.notifier.warning('Error', error.error.message)
    })

  }

  fetchWallet() {
    this.loading = true
    let key = this.componentKey(EventKey.WALLET.FETCH_MY_WALLET())
    this.walletService.fetchMyWallet(key, {})
    this.subscribe(key, null, (value, meta) => {
      this.wallet = meta.data
      this.loading = false
    })

    this.subscribe(this.getErrorKey(key), null, (value, meta) => {
      let error: HttpErrorResponse = meta.data
      this.notifier.warning('Error', error.error.message)
    })
  }

  getRedeemedAmount(): number {
    if (this.leaderboard == null) return 0
    return this.leaderboard.points - this.leaderboard.available_points
  }

  openRedeemDialog() {
    if (!this.authService.isAuthenticatedAsync()) {
      this.router.navigate(["/auth/login"])
      return
    }

    const dialogRef = this.dialog.open(RedeemComponent);
    let instance = dialogRef.componentInstance
    let points = this.leaderboard?.available_points

    if (points == null) instance.availablePoints = 0
    else instance.availablePoints = points

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit()
      console.log(`Dialog result: ${result}`);
    });
  }

  showLoyaltyPointHint() {
    this.notifier.info(
      "Loyalty point updates every 100 threshold.",
      "When you earn points on app, it's immediately added to your total points." +
      " But your loyalty points account is updated when you reach every 100 points threshold."
    )
  }

  getCurrentBadgeTitle(): string {
    if (this.leaderboard?.current_badge == null)
      return 'N/A'
    return this.leaderboard.current_badge.title
  }

  getBadgeCount(): number {
    if (this.leaderboard == null) return 0
    return this.leaderboard.badges.length
  }

  copyToClipboard(trnx_id: string) {
    TextUtility.copyToClipboard(trnx_id)
    this.notifier.info('Copied', 'Copied to clipboard')
  }

  onCloseClick() {
    this.onCanceled.emit()
  }
}
